/**
 * What counts as "this quick filter is filtering something".
 *
 * ONE predicate, because two readers depend on the same answer and a
 * disagreement between them is invisible: `setQuickValue` drops a value it
 * calls empty, and the panel decides from the same question whether to keep a
 * row visible over a pool that has gone away. A value the writer drops but the
 * reader still counts is an applied filter with no row to clear it.
 *
 * Three shapes qualify as empty: the absent value, the empty id list, and a
 * composite (`{workflowIds, stageIds}`) whose every half has emptied.
 */
export function hasQuickFilterValue(value: unknown): boolean {
  if (value == null || value === "") return false;
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === "object") {
    return Object.values(value as Record<string, unknown>).some((half) =>
      Array.isArray(half) ? half.length > 0 : half != null && half !== "",
    );
  }
  return true;
}
